import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var RadioReceiver = createReactComponent("RadioReceiver", ["svg", defaultAttributes, [["path", {
  d: "M5 16v2",
  key: "czliuy"
}], ["path", {
  d: "M19 16v2",
  key: "1f2n3c"
}], ["rect", {
  x: "2",
  y: "8",
  width: "20",
  height: "8",
  rx: "2",
  key: "37yfvc"
}], ["path", {
  d: "M18 12h0",
  key: "149gs7"
}]]]);
export default RadioReceiver;